(() => {
  if (document.documentElement.dir !== 'rtl') return;

  const slidesFor = (component) => Array.from(component.querySelectorAll('.slider__slide'));

  const visibleIndex = (slider, slides) => {
    const viewport = slider.getBoundingClientRect();
    let bestIndex = 0;
    let bestDistance = Infinity;

    slides.forEach((slide, index) => {
      const rect = slide.getBoundingClientRect();
      const distance = Math.abs(viewport.right - rect.right);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    return bestIndex;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.slider-button--prev, .slider-button--next');
    if (!button) return;

    const component = button.closest('slider-component, slideshow-component');
    const slider = component?.querySelector('.slider');
    if (!component || !slider) return;

    const slides = slidesFor(component);
    if (!slides.length) return;

    const current = visibleIndex(slider, slides);
    const targetIndex = Math.max(
      0,
      Math.min(slides.length - 1, current + (button.classList.contains('slider-button--next') ? 1 : -1))
    );
    const target = slides[targetIndex];
    if (!target || targetIndex === current) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }, true);
})();
